import { Component, Inject, OnInit } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { BooleanCons, MessageType, RolesString } from 'src/app/constants/const';
import {
  Container,
  ContainerSelectorActions,
  ContainerSelectorEstructor,
  RequestContainers,
} from 'src/app/model/http/container-selector.model';
import { CalculationService } from 'src/app/services/calculation.service';
import { ContainerService } from 'src/app/services/container.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { CommonService } from '../../services/common.service';
import { NumberCons } from '../../constants/const';
import { DialogService } from 'src/app/services/dialog.service';
import { Messages } from 'src/app/constants/messages';
import { TypeIcon } from 'src/app/model/device/message.model';
import { NotificationMessageComponent } from '../notification-message/notification-message.component';

@Component({
  selector: 'app-container-selector',
  templateUrl: './container-selector.component.html',
  styleUrls: ['./container-selector.component.scss'],
})
export class ContainerSelectorComponent implements OnInit {
  containers: Container[] = [];
  activeContainer = new Container();
  showModal = BooleanCons.true;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ContainerSelectorEstructor,
    private dialogRef: MatDialogRef<ContainerSelectorEstructor>,
    private containerService: ContainerService,
    private commonService: CommonService,
    private localStorageService: LocalStorageService,
    private calculationService: CalculationService,
    private dialogService: DialogService
  ) {}

  ngOnInit(): void {
    this.getContainers();
  }

  changeSelection(newActiveContainer: Container): void {
    this.containers.forEach((container) => {
      if (container.description === newActiveContainer.description) {
        container.isSelected = true;
        this.activeContainer = container;
      } else {
        container.isSelected = BooleanCons.false;
      }
    });
  }

  getContainers(): void {
    const cardCode = this.commonService.calculateTernary(
      this.localStorageService.getUserInRole() === RolesString.doctor,
      this.localStorageService.getCardCode(),
      this.localStorageService.getCardCodeGeneral()
    );
    const request = new RequestContainers();
    request.cardCode = cardCode;
    request.description = this.data.product.description;
    request.itemCode = this.data.product.itemCode;
    request.clientType = this.localStorageService.getClientType();
    request.priceListId = Number(this.localStorageService.getPriceList());
    this.containerService.getContainers(request).subscribe(
      (response) => {
        this.containers = response.response ?? [];
        this.containers.forEach((container) => {
          container.priceWithIvaDiscount =
            (container.priceWithDiscount ?? 0) +
            this.calculationService.getIvaOfProducts(
              container.priceWithDiscount ?? 0,
              container.taxRate
            );
          container.priceWithIVA =
            this.calculationService.calculateContainerIVA(container);
          container.priceWithIVA = this.commonService.calculateTernary(
            isNaN(container.priceWithIVA),
            NumberCons.zero,
            container.priceWithIVA
          );
        });
        if (
          this.commonService.validateOrValue(
            this.commonService.validateAndValue([
              this.data.action === ContainerSelectorActions.addContainer,
              this.containers.length > 0,
            ]),

            this.commonService.validateAndValue([
              this.data.action === ContainerSelectorActions.changeContainer,
              this.containers.length > NumberCons.zero,
              this.containers.filter(
                (container) =>
                  container.description === this.data.data.description
              ).length === NumberCons.zero,
            ])
          )
        ) {
          this.activeContainer.description = this.containers[0].description;
          this.changeSelection(this.containers[0]);
        } else {
          this.changeSelection(this.data.data);
        }
      }
    );
  }

  accept(): void {
    if (
      this.commonService.validateAndValue([
        this.data.containersInProduct.some(
          (attribute) => attribute === this.activeContainer.description
        ),
        this.data.data.description !== this.activeContainer.description,
      ])
    ) {
      const message = `El envase <strong> ${this.activeContainer.description} </strong> ya se encuentra en el producto <strong> ${this.data.product.itemCode} </strong>,
      favor de elegir un envase diferente`;
      this.dialogService.openNotificationGeneric(NotificationMessageComponent, {
        typeMessage: MessageType.general,
        textToShow: message,
        typeIcon: TypeIcon.error,
        containsInnerHtml: true,
      });
      return;
    }
    this.data.data = this.activeContainer;
    this.dialogRef.close({ data: this.data });
  }
}
